export default __webpack_public_path__ + "static/media/dowanloadappAndroid.f902960a.png";